import App from 'app/app.js';
import 'app/directive/LtEnhancedPayOnlySummaryCtrl.js';

function LtEnhancedPayOnlySummaryDirective() {
  return {
    restrict: 'E',
    scope: {
      isScrollable: '=',
      firstName: '@',
      editIndex: '=',
      packageItemViews: '=',
      totalAmount: '@',
      onSaveToCart: '&',
      continueClick: '=',
      pricingError: '=',
      onBackToHome: '&'
    },
    template:
      '<div ng-init="enhancedPayOnlySummary.init()"> ' +
      '   <div class="shopping-cart-summary"> ' +
      '       <div class="shopping-cart-summary-content"> ' +
      '            <div class="row"> ' +
      '                <div class="col-xs-12"><span lt-translate="SPEC_ENHANCED_ORDER_SUMMARY_TITLE" lt-translate-values="{subjectName: firstName}" class="ng-scope"></div> ' +
      '            </div> ' +
      '            <div class="family-approval-total"> ' +
      '                <div class="row"> ' +
      '                    <div class="col-xs-6"> ' +
      '                        <span lt-translate="ENHANCED_PAY_ONLY_TOTAL"></span> ' +
      '                    </div> ' +
      '                    <div class="col-xs-6"> ' +
      '                        <span ng-bind="totalAmount | CurrencyLocaleFilter " data-test-total-amount></span> ' +
      '                    </div> ' +
      '                </div> ' +
      '            </div> ' +
      '            <div class="family-approval-checked" ng-hide="enhancedPayOnlySummary.isNoItemSelected()"> ' +
      '                <div class="row" ng-repeat="packageItemView in packageItemViews"> ' +
      '                    <div class="col-xs-12" ng-show="packageItemView.selected"> ' +
      '                        <span ng-bind="packageItemView.item | ItemDescFilter"></span> ' +
      '                    </div> ' +
      '                </div> ' +
      '            </div> ' +
      '            <div class="family-approval-returned" ng-show="enhancedPayOnlySummary.isSheetsToReturn()"> ' +
      '                <div class="row"> ' +
      '                    <div class="col-xs-12"> ' +
      '                        <span lt-translate="ENHANCED_PAY_ONLY_SHEETS_TO_RETURN"></span> ' +
      '                    </div> ' +
      '                </div> ' +
      '                <div class="row" ng-repeat="packageItemView in packageItemViews"> ' +
      '                    <div class="col-xs-12" ng-hide="packageItemView.selected"> ' +
      '                        <span ng-bind="packageItemView.item | ItemDescFilter"></span> ' +
      '                    </div> ' +
      '                </div> ' +
      '            </div> ' +
      '        </div> ' +
      '    </div> ' +
      '    <div class="row"> ' +
      '        <div class="cart-buttons"> ' +
      '            <div class="col-xs-12 payBtn" > ' +
      '                <a class="btn full-width" lt-translate="ENHANCED_PAY_ONLY_ADD_TO_CART" ' +
      '                   ng-hide="enhancedPayOnlySummary.isNoItemSelected() || enhancedPayOnlySummary.isEditPackage() || pricingError" ' +
      '                   ng-click="enhancedPayOnlySummary.saveToCart()" data-test-enhanced-add-to-cart></a>' +
      '                <a class="btn full-width ng-scope" lt-translate="PACKAGE_DETAIL_SAVE" ' +
      '                   ng-show="!enhancedPayOnlySummary.isNoItemSelected() && enhancedPayOnlySummary.isEditPackage() && !pricingError" ' +
      '                   ng-click="enhancedPayOnlySummary.saveToCart()" ></a> ' +
      '                <a class="btn full-width" lt-translate="ENHANCED_PAY_ONLY_CONTINUE" ' +
      '                   ng-show="enhancedPayOnlySummary.isNoItemSelected() && !pricingError"' +
      '                   ng-click="enhancedPayOnlySummary.onContinue()"></a> ' +
      '               <a class="btn full-width" lt-translate="ENHANCED_PAY_DRAWER_BACK_TO_HOMEPAGE_TEXT" ' +
      '                   ng-show="pricingError"' +
      '                   ng-click="enhancedPayOnlySummary.backToHome()"></a> ' +
      '            </div> ' +
      '        </div> ' +
      '    </div>' +
      '</div> ',
    controller: 'LtEnhancedPayOnlySummaryCtrl',
    controllerAs: 'enhancedPayOnlySummary'
  };
}

App.directive('ltEnhancedPayOnlySummary', [LtEnhancedPayOnlySummaryDirective]);
